import { ReactNode, createContext, useMemo, useRef } from 'react';
import { UpgradeHandoffClaimState } from './types';

export const UpgradeHandoffClaimContext =
    createContext<UpgradeHandoffClaimState>(undefined!);

type Props = { children: ReactNode };

// TransitionDialogManager.onUpgrade() seeds `accessCode` synchronously,
// before showRegistrationDialog()'s query write (registrationFlow, rdo)
// lands. RegistrationDialogManager re-renders off that same accessCode
// change and, without this, can briefly see an eligible-looking access
// code alongside a still-stale registrationFlow, reclaiming a dialog
// onUpgrade() just opened. This ref is synchronous, so it's already
// correct by the time that re-render happens, unlike the two query flags
// racing each other.
export function UpgradeHandoffClaimProvider({ children }: Props) {
    const claimedAccessCodeRef = useRef<string | null>(null);

    const value = useMemo<UpgradeHandoffClaimState>(
        () => ({
            claimAccessCode: (accessCode) => {
                claimedAccessCodeRef.current = accessCode;
            },
            isAccessCodeClaimed: (accessCode) =>
                Boolean(accessCode) &&
                claimedAccessCodeRef.current === accessCode,
        }),
        []
    );

    return (
        <UpgradeHandoffClaimContext.Provider value={value}>
            {children}
        </UpgradeHandoffClaimContext.Provider>
    );
}
